import { defineNuxtPlugin } from "#app";
export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      downloadFile: (url) => {
        if (window.native_download) {
          window.native_download.postMessage(url);
        } else {
          window.location.href = url;
        }
      }
    }
  };
});
